import React from "react";
import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { BookButton } from "@/components/site/BookButton";
import { Seo } from "@/components/site/Seo";

const STEPS = [
  ["Consultation & History", "We start by listening — understanding your story, your symptoms and what you want back."],
  ["Comprehensive Chain Evaluation", "A functional movement assessment looking at how your body works as a connected system."],
  ["Diagnostics If Needed", "When appropriate, we gather the additional information needed to understand the picture."],
  ["Your Custom Care Plan", "A clear, individualized plan — explained in plain language so you know exactly what comes next."],
  ["Begin Care", "Hands-on care and movement work, with reassessment built in from the very start."],
];

export default function FirstVisit() {
  return (
    <div>
      <Seo title="Your First Visit | Psalm 30:2 Chiropractic Gardner KS" description="What to expect on your first visit to Psalm 30:2 Chiropractic — a calm, unhurried, individualized experience." />
      <PageHero eyebrow="First Visit" title={<>What to expect,<br />start to finish.</>} intro="Your first visit is unhurried and personal. Here's exactly how it flows." />
      <section className="bg-ivory pb-28 px-6 md:px-10 lg:px-14" data-testid="first-visit-steps">
        <div className="max-w-3xl mx-auto">
          {STEPS.map(([t, d], i) => (
            <Reveal key={t} delay={i * 60}>
              <div className="flex gap-8 py-8 border-t border-espresso/10">
                <span className="font-serif text-4xl text-brass shrink-0 w-14">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h3 className="font-serif text-3xl text-espresso mb-2">{t}</h3>
                  <p className="text-espressosoft/80 font-light leading-relaxed">{d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="bg-linen py-20 px-6 text-center">
        <Reveal>
          <BookButton label="Book Your First Visit" variant="primary" track_label="first-visit" testid="first-visit-book-button" />
        </Reveal>
      </section>
    </div>
  );
}
